<script setup>

const { section } = defineProps({
	section: Object
})

const emit = defineEmits(['selectionSection']);

</script>

<template>
	<div class="sous-section" 
		@dblclick="emit('selectionSection')">
		<i class="fa fa-angle-right" />
		{{ section.nom }}
	</div>
</template>

<style scoped>

.sous-section {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-evenly;
	border-style: solid;
	border-width: 0px;
	gap: 10px 5px;
	color: var(--couleur-primaire);
	font-size: larger;
	padding-left: 10px;
	user-select: none;
}

</style>